/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    object, shape, string, array, func,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isRetailOrSale from '../../../../../../helpers/isRetailOrSale';
import { trackEvent as trackEventAction } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    root: {
        boxShadow: '0 2px 3px rgba(59,33,81,0.15), 0 2px 2px rgba(59,33,81,0.15)',
        border: '1px solid #EDEDED',
        margin: '10px 0',
        position: 'relative',
        borderRadius: '3px',
        marginLeft: '120px', // match the alt images: 110 width, 10 margin right = 120px
        maxWidth: '600px',
        [theme?.breakpoints?.down('md')]: {
            marginLeft: '0',
            maxWidth: '100%',
            minWidth: '100%',
        },

        '&--ThreeColumn': {
            marginLeft: 0,
        },

        '@media screen and (min-width: 1024px) and (max-width: 1366px)': {
            marginLeft: '0',
            maxWidth: 'calc(100% - 120px)',
            float: 'right',
            width: '100%',
            minWidth: '352px',
            alignSelf: 'flex-end',
            '&--ThreeColumn': {
                maxWidth: '100%',
            },
        },
        '@media screen and (min-width: 1024px) and (max-width: 1279px)': {
            maxWidth: '100%',
        },
    },
    smartGiftContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        background: theme?.palette?.white,
        margin: '20px',
        flexWrap: 'nowrap',
        '& button': {
            color: theme?.palette?.common.white,
            minHeight: '28px',
            padding: '4px 8px',
            alignSelf: 'center',
            fontWeight: 'normal',
            borderRadius: '4px',
            cursor: 'pointer',
            margin: '0',
            display: 'inline',
            fontSize: '14px',
            textDecoration: 'none',
            background: theme.palette.cms?.flowerPdpButton || '#61C278',
            border: 'inherit',
        },
        [theme?.breakpoints?.down('md')]: {
            flexWrap: 'wrap',
        },
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        '& svg': {
            fontSize: '25px',
            fill: 'currentColor',
            width: '1em',
            height: '1em',
            display: 'inline - block',
            userSelect: 'none',
            flexShrink: '0',
            '&:first-child': {
                fontSize: '35px',
                color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            },
        },
    },
    copyContainer: {
        flex: '1 0 50%',
        margin: '10px 0 0 0',
        display: 'flex',
        fontSize: '14px',
        alignItems: 'flex- start',
        flexDirection: 'column',
        justifyContent: 'space-around',
        '& span': {
            paddingTop: '5px',
        },
    },
});

class GraphqlSmartGiftUIDesktop extends Component {
    buildGiftPath = (giftUrl, sku, collection) => `${giftUrl}${sku}?categoryId=${collection}&tc=`;

    buildCopy = (copy, classes) => {
        const copySplit = copy?.split('\n') || '';
        return (
            <div
                className={classes.copyContainer}
                data-testid="smart-gift-desktop-copy"
            >
                <strong>{copySplit[0]}</strong>
                <span>{copySplit[1]}</span>
                <span>{copySplit[2]}</span>
            </div>
        );
    }

    smartGiftSend = () => {
        const {
            location: {
                state,
                pathname,
            },
            productName,
            sku,
            price,
            image,
            trackEvent,
        } = this.props;

        trackEvent({
            eventCategory: 'Product Page',
            eventAction: 'Smart Gift Click',
            eventLabel: productName,
        });

        if (typeof window !== 'undefined' && window.SGBasket) {
            window.SGBasket.addItem({
                skuCode: sku.match(/[^-_]*$/)[0], // '(string | required ) the unique identifier of the sku',
                skuUrl: pathname, // '(string | required ) the current PDP URL',
                price: isRetailOrSale(price), // '(float | required) the price of the SKU',
                name: productName, // '(string | required) The name of the product',
                image, // '(string | required) The image url of the product',
                quantity: '1.0',
                customParameters: {
                    categoryId: state?.categoryId,
                    source: 'smg',
                    SCILocNumber: '',
                }, // '(object | Optional) the custom parameters as in key-value pairs',
            });
        }
    }

    render() {
        const {
            classes, giftData: {
                button_copy, copy,
            },
            pdpVariantName,
        } = this.props;

        let rootStyles = `${classes.root}`;
        if (pdpVariantName === 'ThreeColumn') {
            // threee column has the  smart gift widget on right side and needs special styling
            rootStyles += ` ${classes.root}--ThreeColumn`;
        }

        return (
            <div
                className={rootStyles}
                data-testid="smart-gift-ui-desktop"
            >
                <div className={classes.smartGiftContainer} id="smartgift-container">
                    <div className={classes.iconContainer}>
                        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                            <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" />
                            <path fill="none" d="M0 0h24v24H0z" />
                        </svg>
                        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                        <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                    </div>
                    {this.buildCopy(copy, classes)}
                    <button type="button" id="send-smartgift" onClick={this.smartGiftSend}>
                        <span>{button_copy}™</span>
                    </button>
                </div>
            </div>
        );
    }
}

GraphqlSmartGiftUIDesktop.propTypes = {
    location: shape({
        state: object,
    }),
    pdpVariantName: string,
    classes: object.isRequired,
    giftData: shape({
        button_copy: string.isRequired,
        button_color: string.isRequired,
        copy: string.isRequired,
    }).isRequired,
    productName: string.isRequired,
    sku: string.isRequired,
    price: array.isRequired,
    image: string.isRequired,
    trackEvent: func.isRequired,
};

GraphqlSmartGiftUIDesktop.defaultProps = {
    location: {
        state: {},
    },
    pdpVariantName: '',
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(trackEventAction, dispatch),
});

const enhance = compose(
    withRouter,
    connect(null, mapDispatchToProps),
    withStyles(styles),
);

export default enhance(GraphqlSmartGiftUIDesktop);
